// Always get the API URL from the environment variable, or default to localhost if not set
const RUTA_SERVIDOR = process.env.VUE_APP_API_URL || 'http://127.0.0.1:8000/api';
const manejarRespuesta = (respuesta) => {
  return respuesta;
};

import {ResourcesService} from '@/services/ResourcesService'

export const HttpClient = {
  post: async (ruta, datos) => await fetch(RUTA_SERVIDOR + ruta, {
    credentials: 'include',
    headers: {
      'Authorization': `Bearer ${ResourcesService.getToken()}`,
      'Accept': 'application/json'
    },
    method: 'POST',
    body: datos,
  })
    .catch(error => {// Simple error handling to avoid vue warnings in console in development mode
      console.error('Error en la solicitud POST:', error);
      throw error;
    })
    .then(r => r.json())
    .then(manejarRespuesta),

  postJSON: async (ruta, datos) => await fetch(RUTA_SERVIDOR + ruta, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${ResourcesService.getToken()}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify(datos),
    credentials: 'include',
  })
    .then(r => r.json())
    .then(manejarRespuesta),
  put: async (ruta, datos) => await fetch(RUTA_SERVIDOR + ruta, {
    credentials: 'include',
    headers: {
      'Authorization': `Bearer ${ResourcesService.getToken()}`,
      'Accept': 'application/json'
    },
    method: 'PUT',
    body: datos,
  })
    .catch(error => { // Simple error handling
      console.error('Error en la solicitud PUT:', error);
      throw error;
    })
    .then(r => r.json())
    .then(manejarRespuesta),
  putJSON: async (ruta, datos) => await fetch(RUTA_SERVIDOR + ruta, {
    credentials: 'include',
    headers: {
      'Authorization': `Bearer ${ResourcesService.getToken()}`,
      'Content-Type': 'application/json'
    },
    method: 'PUT',
    body: JSON.stringify(datos),
  })
    .catch(error => {
      console.error('Error en la solicitud PUT (JSON):', error);
      throw error;
    })
    .then(r => r.json())
    .then(manejarRespuesta),
  get: async (ruta, options = {}) => await fetch(RUTA_SERVIDOR + ruta, {
    credentials: 'include',
    signal: options.signal,
    headers: {
      'Authorization': `Bearer ${ResourcesService.getToken()}`,
      'Accept': 'application/json'
    }
  })
    .catch(error => {// Simple error handling to avoid vue warnings in console in development mode
      console.error('Error en la solicitud GET:', error);
      throw error;
    })
    .then(r => r.json())
    .then(manejarRespuesta),
  delete: async ruta => await fetch(RUTA_SERVIDOR + ruta, {
    credentials: 'include',
    headers: {
      'Authorization': `Bearer ${ResourcesService.getToken()}`,
      'Accept': 'application/json'
    },
    method: 'DELETE',
  })
    .catch(error => {// Simple error handling to avoid vue warnings
      console.error('Error en la solicitud DELETE:', error);
      throw error;
    })
    .then(r => r.json())
    .then(manejarRespuesta),
};

export default { HttpClient };
